import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, TrendingDownIcon, AlertTriangleIcon, CheckCircleIcon, XCircleIcon, ClockIcon, SearchIcon, RefreshCwIcon, ArrowRightIcon, LockIcon, DownloadIcon, StarIcon, BookOpenIcon, CheckIcon, MapIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 40
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1
    }
  },
  viewport: {
    once: true
  }
};
const staggerItem = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.5
  }
};
const slideInLeft = {
  initial: {
    opacity: 0,
    x: -60
  },
  whileInView: {
    opacity: 1,
    x: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function SalesPage() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/2Ro8qorMx9uWSgGjXJs433/heylloyd-BLINDAJE_DOMESTICO-1771356411047.png';
  return <main className="w-full min-h-screen bg-white" data-id="element-2">
      {/* HERO SECTION */}
      <section className="w-full bg-[#0f1e3d] py-16 md:py-24 px-4" data-id="element-3">
        <div className="max-w-5xl mx-auto text-center" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} data-id="element-5">
            <span className="inline-block px-4 py-2 bg-[#c9a227]/20 border border-[#c9a227] text-[#c9a227] text-xs md:text-sm font-semibold tracking-wider rounded-full mb-6" data-id="element-6">
              SISTEMA DE BLINDAJE 3/7 — EXCLUSIVO PARA VENEZUELA
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-7">
            Cómo estirar tu presupuesto un{' '}
            <span className="text-[#c9a227]" data-id="element-8">30%</span> en Venezuela sin ganar
            más dinero
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10" data-id="element-9">
            El manual operativo que separa a los que "ven el dinero pasar" de
            los que logran que cada Bolívar y cada Dólar rinda al máximo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.5
        }} className="relative mb-10" data-id="element-10">
            <div className="absolute inset-0 bg-[#c9a227]/20 blur-3xl rounded-full scale-75" data-id="element-11" />
            <img src={productImage} alt="Blindaje Doméstico - Manual de Gestión de Crisis" className="relative mx-auto max-w-md md:max-w-lg lg:max-w-xl w-full h-auto drop-shadow-2xl" data-id="element-12" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="mb-6" data-id="element-13"></motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.8
        }} data-id="element-14">
            <a href="#comprar" className="inline-flex items-center gap-3 px-8 py-4 bg-[#c9a227] hover:bg-[#e8c84a] text-[#0f1e3d] text-lg md:text-xl font-bold rounded-lg transition-all duration-300 animate-pulse-gold" data-id="element-15">
              QUIERO BLINDAR MI PRESUPUESTO AHORA
              <ArrowRightIcon className="w-5 h-5" data-id="element-16" />
            </a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 1
        }} className="mt-6 text-sm text-gray-400 flex flex-wrap justify-center gap-4" data-id="element-17">
            <span className="flex items-center gap-1" data-id="element-18">
              <CheckIcon className="w-4 h-4 text-[#c9a227]" data-id="element-19" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-20">
              <CheckIcon className="w-4 h-4 text-[#c9a227]" data-id="element-21" /> PDF descargable
            </span>
            <span className="flex items-center gap-1" data-id="element-22">
              <CheckIcon className="w-4 h-4 text-[#c9a227]" data-id="element-23" /> Aplicable desde
              el primer día
            </span>
          </motion.p>
        </div>
      </section>

      {/* OPENING LEAD / AGITATION */}
      <section className="w-full bg-[#faf8f3] py-16 md:py-24 px-4" data-id="element-24">
        <div className="max-w-4xl mx-auto" data-id="element-25">
          <motion.p {...fadeInUp} className="text-xl md:text-2xl lg:text-3xl text-[#1a1a2e] leading-relaxed text-center mb-16" data-id="element-26">
            <span className="font-semibold" data-id="element-27">
              Usted lo sabe mejor que nadie:
            </span>{' '}
            en Venezuela, el dinero tiene fecha de vencimiento. Cobra hoy, y si
            no se mueve rápido,{' '}
            <span className="text-[#c9a227] font-bold" data-id="element-28">
              mañana su esfuerzo vale la mitad.
            </span>
          </motion.p>

          <div className="space-y-6" data-id="element-29">
            <motion.div {...slideInLeft} transition={{
            duration: 0.6,
            delay: 0
          }} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#c9a227] flex gap-4" data-id="element-30">
              <div className="flex-shrink-0" data-id="element-31">
                <ShieldIcon className="w-8 h-8 text-[#c9a227]" data-id="element-32" />
              </div>
              <div data-id="element-33">
                <h3 className="text-lg font-bold text-[#0f1e3d] mb-2" data-id="element-34">
                  Cobra hoy y mañana vale la mitad
                </h3>
                <p className="text-gray-600" data-id="element-35">
                  La devaluación no espera. Cada hora que el dinero duerme en su
                  cuenta, pierde valor real.
                </p>
              </div>
            </motion.div>

            <motion.div {...slideInLeft} transition={{
            duration: 0.6,
            delay: 0.15
          }} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#c9a227] flex gap-4" data-id="element-36">
              <div className="flex-shrink-0" data-id="element-37">
                <TrendingDownIcon className="w-8 h-8 text-[#c9a227]" data-id="element-38" />
              </div>
              <div data-id="element-39">
                <h3 className="text-lg font-bold text-[#0f1e3d] mb-2" data-id="element-40">
                  Las aplicaciones de finanzas no funcionan aquí
                </h3>
                <p className="text-gray-600" data-id="element-41">
                  Los consejos de "ahorre el 10%" son un chiste cuando la
                  inflación sube a diario.
                </p>
              </div>
            </motion.div>

            <motion.div {...slideInLeft} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#c9a227] flex gap-4" data-id="element-42">
              <div className="flex-shrink-0" data-id="element-43">
                <AlertTriangleIcon className="w-8 h-8 text-[#c9a227]" data-id="element-44" />
              </div>
              <div data-id="element-45">
                <h3 className="text-lg font-bold text-[#0f1e3d] mb-2" data-id="element-46">
                  Trabajas solo para comer
                </h3>
                <p className="text-gray-600" data-id="element-47">
                  No es que gastes de más. Es que sin sistema, tienes un agujero
                  invisible en el bolsillo.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-48">
        <div className="max-w-4xl mx-auto" data-id="element-49">
          <motion.span {...fadeInUp} className="block text-[#c9a227] text-sm font-bold tracking-widest uppercase mb-4 text-center" data-id="element-50">
            ¿POR QUÉ LAS SOLUCIONES ANTIGUAS FALLARON?
          </motion.span>

          <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-bold text-[#0f1e3d] text-center mb-8" data-id="element-51">
            Intentar ahorrar en una moneda que se devalúa es una batalla
            perdida.
          </motion.h2>

          <motion.p {...fadeInUp} className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto" data-id="element-52">
            Lo que usted necesita no es ahorrar papel; es{' '}
            <span className="font-semibold text-[#0f1e3d]" data-id="element-53">
              blindar su poder adquisitivo
            </span>{' '}
            convirtiendo el dinero en bienes y estabilidad en el momento exacto.
            Las reglas financieras del resto del mundo no aplican aquí.
          </motion.p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-54">
            <motion.div {...fadeInUp} className="space-y-4" data-id="element-55">
              <h3 className="text-lg font-bold text-red-600 flex items-center gap-2" data-id="element-56">
                <XCircleIcon className="w-5 h-5" data-id="element-57" /> Lo que NO funciona
              </h3>
              <div className="space-y-3" data-id="element-58">
                <div className="flex items-start gap-3 text-gray-600" data-id="element-59">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-60" />
                  <span data-id="element-61">Guardar Bolívares "para después"</span>
                </div>
                <div className="flex items-start gap-3 text-gray-600" data-id="element-62">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-63" />
                  <span data-id="element-64">Usar apps de presupuesto extranjeras</span>
                </div>
                <div className="flex items-start gap-3 text-gray-600" data-id="element-65">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-66" />
                  <span data-id="element-67">Seguir la regla del 50/30/20</span>
                </div>
                <div className="flex items-start gap-3 text-gray-600" data-id="element-68">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-69" />
                  <span data-id="element-70">Comprar sin estrategia de timing</span>
                </div>
              </div>
            </motion.div>

            <motion.div {...fadeInUp} className="space-y-4" data-id="element-71">
              <h3 className="text-lg font-bold text-[#c9a227] flex items-center gap-2" data-id="element-72">
                <CheckCircleIcon className="w-5 h-5" data-id="element-73" /> Lo que SÍ funciona
              </h3>
              <div className="space-y-3" data-id="element-74">
                <div className="flex items-start gap-3 text-gray-600" data-id="element-75">
                  <CheckCircleIcon className="w-5 h-5 text-[#c9a227] flex-shrink-0 mt-0.5" data-id="element-76" />
                  <span data-id="element-77">Convertir dinero en bienes estratégicos</span>
                </div>
                <div className="flex items-start gap-3 text-gray-600" data-id="element-78">
                  <CheckCircleIcon className="w-5 h-5 text-[#c9a227] flex-shrink-0 mt-0.5" data-id="element-79" />
                  <span data-id="element-80">Sistema diseñado para Venezuela</span>
                </div>
                <div className="flex items-start gap-3 text-gray-600" data-id="element-81">
                  <CheckCircleIcon className="w-5 h-5 text-[#c9a227] flex-shrink-0 mt-0.5" data-id="element-82" />
                  <span data-id="element-83">Algoritmo de prioridad inflacionaria</span>
                </div>
                <div className="flex items-start gap-3 text-gray-600" data-id="element-84">
                  <CheckCircleIcon className="w-5 h-5 text-[#c9a227] flex-shrink-0 mt-0.5" data-id="element-85" />
                  <span data-id="element-86">Protocolo de conversión de 60 minutos</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SOLUTION INTRODUCTION */}
      <section className="w-full bg-[#0f1e3d] py-16 md:py-24 px-4" data-id="element-87">
        <div className="max-w-4xl mx-auto" data-id="element-88">
          <motion.span {...fadeInUp} className="block text-[#c9a227] text-sm font-bold tracking-widest uppercase mb-4 text-center" data-id="element-89">
            LA SOLUCIÓN
          </motion.span>

          <motion.h2 {...fadeInUp} className="text-3xl md:text-5xl font-bold text-white text-center mb-6" data-id="element-90">
            Por eso creamos:{' '}
            <span className="text-[#c9a227]" data-id="element-91">Blindaje Doméstico</span>
          </motion.h2>

          <motion.p {...fadeInUp} className="text-lg md:text-xl text-gray-300 text-center mb-12 max-w-2xl mx-auto" data-id="element-92">
            Este no es un libro de economía teórica. Es un{' '}
            <span className="text-white font-semibold" data-id="element-93">manual operativo</span>{' '}
            diseñado exclusivamente para la realidad venezolana.
          </motion.p>

          <motion.div {...fadeInUp} className="relative max-w-sm mx-auto" data-id="element-94">
            <div className="absolute inset-0 bg-[#c9a227]/30 blur-2xl rounded-full" data-id="element-95" />
            <img src={productImage} alt="Blindaje Doméstico" className="relative w-full h-auto drop-shadow-xl" data-id="element-96" />
          </motion.div>
        </div>
      </section>

      {/* WHAT'S INSIDE - 4 MODULES */}
      <section className="w-full bg-[#faf8f3] py-16 md:py-24 px-4" data-id="element-97">
        <div className="max-w-5xl mx-auto" data-id="element-98">
          <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-bold text-[#0f1e3d] text-center mb-12" data-id="element-99">
            Lo que descubrirá dentro del Manual
          </motion.h2>

          <motion.div {...staggerContainer} className="grid md:grid-cols-2 gap-6" data-id="element-100">
            <motion.div {...staggerItem} className="bg-white p-6 rounded-xl shadow-lg relative overflow-hidden" data-id="element-101">
              <span className="absolute top-4 right-4 w-10 h-10 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-lg" data-id="element-102">
                1
              </span>
              <SearchIcon className="w-10 h-10 text-[#c9a227] mb-4" data-id="element-103" />
              <h3 className="text-xl font-bold text-[#0f1e3d] mb-3" data-id="element-104">
                La Auditoría de Fuga
              </h3>
              <p className="text-gray-600" data-id="element-105">
                Localice los 3 puntos donde su hogar pierde dinero sin que usted
                se dé cuenta (incluye la trampa del Pago Móvil).
              </p>
            </motion.div>

            <motion.div {...staggerItem} className="bg-white p-6 rounded-xl shadow-lg relative overflow-hidden" data-id="element-106">
              <span className="absolute top-4 right-4 w-10 h-10 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-lg" data-id="element-107">
                2
              </span>
              <ClockIcon className="w-10 h-10 text-[#c9a227] mb-4" data-id="element-108" />
              <h3 className="text-xl font-bold text-[#0f1e3d] mb-3" data-id="element-109">
                El Algoritmo 3/7
              </h3>
              <p className="text-gray-600" data-id="element-110">
                El método exacto para saber qué comprar, cuándo comprar y dónde,
                adelantándose al marcaje de precios.
              </p>
            </motion.div>

            <motion.div {...staggerItem} className="bg-white p-6 rounded-xl shadow-lg relative overflow-hidden" data-id="element-111">
              <span className="absolute top-4 right-4 w-10 h-10 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-lg" data-id="element-112">
                3
              </span>
              <RefreshCwIcon className="w-10 h-10 text-[#c9a227] mb-4" data-id="element-113" />
              <h3 className="text-xl font-bold text-[#0f1e3d] mb-3" data-id="element-114">
                Ingeniería de Sustitución
              </h3>
              <p className="text-gray-600" data-id="element-115">
                Cómo mantener su calidad de vida optimizando el gasto en
                artículos de higiene y limpieza con productos técnica y
                químicamente idénticos a las marcas caras.
              </p>
            </motion.div>

            <motion.div {...staggerItem} className="bg-white p-6 rounded-xl shadow-lg relative overflow-hidden" data-id="element-116">
              <span className="absolute top-4 right-4 w-10 h-10 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-lg" data-id="element-117">
                4
              </span>
              <ShieldIcon className="w-10 h-10 text-[#c9a227] mb-4" data-id="element-118" />
              <h3 className="text-xl font-bold text-[#0f1e3d] mb-3" data-id="element-119">
                Protocolo de Conversión
              </h3>
              <p className="text-gray-600" data-id="element-120">
                La regla de los 60 minutos para que el dinero nunca muera en su
                cuenta bancaria.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* WHO IT'S FOR */}
      <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-121">
        <div className="max-w-3xl mx-auto" data-id="element-122">
          <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-bold text-[#0f1e3d] text-center mb-12" data-id="element-123">
            Esto es para usted si...
          </motion.h2>

          <motion.div {...fadeInUp} className="space-y-4 mb-12" data-id="element-124">
            <div className="flex items-start gap-4 p-4 bg-green-50 rounded-lg" data-id="element-125">
              <CheckCircleIcon className="w-7 h-7 text-green-600 flex-shrink-0" data-id="element-126" />
              <p className="text-lg text-[#1a1a2e]" data-id="element-127">
                <span className="font-semibold" data-id="element-128">Tiene más de 30 años</span> y la
                responsabilidad de un hogar sobre sus hombros.
              </p>
            </div>
            <div className="flex items-start gap-4 p-4 bg-green-50 rounded-lg" data-id="element-129">
              <CheckCircleIcon className="w-7 h-7 text-green-600 flex-shrink-0" data-id="element-130" />
              <p className="text-lg text-[#1a1a2e]" data-id="element-131">
                <span className="font-semibold" data-id="element-132">Siente ansiedad</span> cada vez
                que ve subir el dólar.
              </p>
            </div>
            <div className="flex items-start gap-4 p-4 bg-green-50 rounded-lg" data-id="element-133">
              <CheckCircleIcon className="w-7 h-7 text-green-600 flex-shrink-0" data-id="element-134" />
              <p className="text-lg text-[#1a1a2e]" data-id="element-135">
                Busca una{' '}
                <span className="font-semibold" data-id="element-136">
                  solución práctica, lógica y aplicable
                </span>{' '}
                desde el primer minuto.
              </p>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} className="border-t border-gray-200 pt-8" data-id="element-137">
            <h3 className="text-lg font-semibold text-gray-500 mb-4" data-id="element-138">
              Esto NO es para usted si...
            </h3>
            <div className="space-y-3" data-id="element-139">
              <div className="flex items-start gap-3 text-gray-500" data-id="element-140">
                <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-141" />
                <span data-id="element-142">Busca hacerse rico rápido con inversiones.</span>
              </div>
              <div className="flex items-start gap-3 text-gray-500" data-id="element-143">
                <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-144" />
                <span data-id="element-145">No está dispuesto a aplicar un sistema simple.</span>
              </div>
              <div className="flex items-start gap-3 text-gray-500" data-id="element-146">
                <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-147" />
                <span data-id="element-148">Prefiere seguir improvisando con su dinero.</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* DELIVERABLES */}
      <section className="w-full bg-[#0f1e3d] py-16 md:py-24 px-4" data-id="element-149">
        <div className="max-w-4xl mx-auto" data-id="element-150">
          <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-bold text-[#c9a227] text-center mb-12" data-id="element-151">
            Usted recibirá:
          </motion.h2>

          <motion.div {...staggerContainer} className="space-y-6 mb-12" data-id="element-152">
            <motion.div {...staggerItem} className="flex items-start gap-4 p-6 bg-white/5 backdrop-blur rounded-xl border border-white/10" data-id="element-153">
              <span className="flex-shrink-0 w-12 h-12 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-xl" data-id="element-154">
                1
              </span>
              <div data-id="element-155">
                <BookOpenIcon className="w-6 h-6 text-[#c9a227] mb-2" data-id="element-156" />
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-157">
                  El Manual "Blindaje Doméstico: Gestión de Crisis"
                </h3>
                <p className="text-gray-400" data-id="element-158">PDF de alta densidad</p>
              </div>
            </motion.div>

            <motion.div {...staggerItem} className="flex items-start gap-4 p-6 bg-white/5 backdrop-blur rounded-xl border border-white/10" data-id="element-159">
              <span className="flex-shrink-0 w-12 h-12 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-xl" data-id="element-160">
                2
              </span>
              <div data-id="element-161">
                <CheckCircleIcon className="w-6 h-6 text-[#c9a227] mb-2" data-id="element-162" />
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-163">
                  Checklist: "Protocolo de Compras de Alta Eficiencia"
                </h3>
                <p className="text-gray-400" data-id="element-164">Lista de verificación práctica</p>
              </div>
            </motion.div>

            <motion.div {...staggerItem} className="flex items-start gap-4 p-6 bg-white/5 backdrop-blur rounded-xl border border-white/10" data-id="element-165">
              <span className="flex-shrink-0 w-12 h-12 bg-[#c9a227] text-[#0f1e3d] rounded-full flex items-center justify-center font-bold text-xl" data-id="element-166">
                3
              </span>
              <div data-id="element-167">
                <MapIcon className="w-6 h-6 text-[#c9a227] mb-2" data-id="element-168" />
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-169">
                  Hoja de Ruta: "Conversión y Protección de Capital"
                </h3>
                <p className="text-gray-400" data-id="element-170">Guía paso a paso</p>
              </div>
            </motion.div>
          </motion.div>

          <motion.div {...fadeInUp} className="text-center" data-id="element-171">
            <p className="text-gray-400 mb-2" data-id="element-172">
              <span className="line-through" data-id="element-173">Valor real: $47</span>
            </p>
            <p className="text-3xl md:text-4xl font-bold text-white" data-id="element-174">
              Hoy solo: <span className="text-[#c9a227]" data-id="element-175">$6.39 USD</span>
            </p>
          </motion.div>
        </div>
      </section>

      {/* PRICE + FINAL CTA */}
      <section id="comprar" className="w-full py-16 md:py-24 px-4" style={{
      background: 'linear-gradient(135deg, #c9a227 0%, #e8c84a 100%)'
    }} data-id="element-176">
        <div className="max-w-3xl mx-auto text-center" data-id="element-177">
          <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-bold text-[#0f1e3d] mb-6" data-id="element-178">
            Menos de lo que pierde en una sola semana por una mala decisión de
            compra.
          </motion.h2>

          <motion.div {...fadeInUp} className="mb-6" data-id="element-179">
            <span className="text-5xl md:text-7xl font-black text-[#0f1e3d]" data-id="element-180">
              $6.39 USD
            </span>
          </motion.div>

          <motion.p {...fadeInUp} className="text-lg text-[#0f1e3d]/80 mb-8" data-id="element-181">
            Acceso inmediato. Un solo pago. Sin suscripciones.
          </motion.p>

          <motion.div {...fadeInUp} data-id="element-182">
            <a href="https://app.komvii.com/checkout/TDf6GL5t2xYVZSGX7i6TyMK63IxOm80X?p=MTc2" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-10 py-5 bg-[#0f1e3d] hover:bg-[#1a2d4d] text-white text-xl md:text-2xl font-bold rounded-lg transition-all duration-300 shadow-xl hover:shadow-2xl" data-id="element-183">
              QUIERO BLINDAR MI PRESUPUESTO AHORA
              <ArrowRightIcon className="w-6 h-6" data-id="element-184" />
            </a>
          </motion.div>

          <motion.div {...fadeInUp} className="mt-8 flex flex-wrap justify-center gap-6 text-[#0f1e3d]/80" data-id="element-185">
            <span className="flex items-center gap-2" data-id="element-186">
              <LockIcon className="w-5 h-5" data-id="element-187" /> Pago Seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-188">
              <DownloadIcon className="w-5 h-5" data-id="element-189" /> Descarga Inmediata
            </span>
            <span className="flex items-center gap-2" data-id="element-190">
              <StarIcon className="w-5 h-5" data-id="element-191" /> Aplicable Hoy Mismo
            </span>
          </motion.div>
        </div>
      </section>

      {/* CLOSING URGENCY */}
      <section className="w-full bg-[#faf8f3] py-16 md:py-20 px-4" data-id="element-192">
        <div className="max-w-3xl mx-auto text-center" data-id="element-193">
          <motion.p {...fadeInUp} className="text-xl md:text-2xl text-[#1a1a2e] mb-8" data-id="element-194">
            Es hora de dejar de ser una víctima de los precios y empezar a ser{' '}
            <span className="font-bold text-[#0f1e3d]" data-id="element-195">
              el gerente de su propia economía.
            </span>
          </motion.p>

          <motion.div {...fadeInUp} data-id="element-196">
            <a href="#comprar" className="inline-flex items-center gap-3 px-8 py-4 bg-[#c9a227] hover:bg-[#e8c84a] text-[#0f1e3d] text-lg font-bold rounded-lg transition-all duration-300" data-id="element-197">
              BLINDAR MI PRESUPUESTO
              <ArrowRightIcon className="w-5 h-5" data-id="element-198" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="w-full bg-[#0f1e3d] py-8 px-4" data-id="element-199">
        <div className="max-w-4xl mx-auto text-center text-gray-400 text-sm" data-id="element-200">
          <p data-id="element-201">© 2026 Blindaje Doméstico. Todos los derechos reservados.</p>
        </div>
      </footer>
    </main>;
}